import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const baseStyles = xcss({
	height: '40px',
	width: '44px',
	borderRadius: 'border.radius.100',
	border: 'none',
});

const placeholderStyles = xcss({
	backgroundColor: 'color.background.neutral',
});

export const PlaceholderThumbnail = () => {
	return <Box xcss={[baseStyles, placeholderStyles]} testId="image-picker-placeholders" />;
};
